/* sugar:assets/quiz-answers.js@2.0.0 */
/* Selection behaviour for Quiz Answers and Quiz Scale. Keyed off data attributes only,
   so one copy serves every step on the page. */
(function () {
  function init(root) {
    if (root.dataset.quizAnswersBound === '1') return;
    root.dataset.quizAnswersBound = '1';

    var Q = window.SugarQuiz;
    if (!Q) return;

    var page = root.closest('[data-quiz-page], [data-quiz-loading]');
    var sectionId = page ? page.dataset.quizPage || page.dataset.quizLoading : null;
    if (!sectionId) return;

    var isScale = root.hasAttribute('data-quiz-scale');
    /* Scale points are always single-select, whatever else is configured. */
    var isMulti = !isScale && root.dataset.multi === 'true';

    /* Required first: registerAnswers notifies, and Navigation's dimmed Next reads it. */
    var message = root.dataset.requiredMessage;
    if (message) Q.setPageRequired(sectionId, message);

    Q.registerAnswers(sectionId, isMulti);

    /* Only the two end points of a scale carry a visible range label. */
    var points = root.querySelectorAll('[data-quiz-scale-point]');
    if (points.length) {
      points[0].setAttribute('data-scale-endpoint', '');
      points[points.length - 1].setAttribute('data-scale-endpoint', '');
    }

    var scaleLabel = root.querySelector('[data-quiz-scale-label]');
    var none = root.querySelector('[data-quiz-none]');
    var error = root.querySelector('[data-quiz-error]');

    root.addEventListener('click', function (e) {
      if (none && e.target.closest('[data-quiz-none]')) {
        Q.setAnswers(sectionId, ['__none__']);
        if (!isMulti && Q.nav.hideNextSingle) {
          setTimeout(function () {
            if (Q.isActive(sectionId)) Q.next();
          }, 300);
        }
        return;
      }

      var target = e.target.closest('[data-quiz-answer], [data-quiz-scale-point]');
      if (!target || !target.dataset.answerId) return;
      Q.selectAnswer(sectionId, target.dataset.answerId, isMulti && !target.hasAttribute('data-quiz-scale-point'));
    });

    Q.subscribe(function (q) {
      var selected = q.answers[sectionId] || [];

      root.querySelectorAll('[data-quiz-answer]').forEach(function (el) {
        el.classList.toggle('quiz-answer--selected', selected.indexOf(el.dataset.answerId) !== -1);
      });

      root.querySelectorAll('[data-quiz-scale-point]').forEach(function (el) {
        var on = selected.indexOf(el.dataset.answerId) !== -1;
        el.classList.toggle('quiz-scale-point--selected', on);
        var circle = el.querySelector('.quiz-scale-point__circle');
        if (circle) circle.classList.toggle('quiz-scale-point__circle--selected', on);
      });

      if (none) none.classList.toggle('quiz-none-btn--selected', selected.indexOf('__none__') !== -1);

      /* The scale's centre label mirrors whichever point is currently picked. */
      if (scaleLabel) {
        var picked = selected.length && selected[0] !== '__none__' ? selected[0] : null;
        var point = picked && root.querySelector('[data-quiz-scale-point][data-answer-id="' + picked + '"] .quiz-scale-point__label');
        scaleLabel.hidden = !point;
        scaleLabel.innerHTML = point ? point.innerHTML : '';
      }

      if (error) error.hidden = q.validationError !== sectionId;
    });
  }

  function scan(scope) {
    var r = scope && scope.querySelectorAll ? scope : document;
    r.querySelectorAll('[data-quiz-answers-root]').forEach(init);
  }

  window.SugarReady(function () {
    scan(document);
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
    document.addEventListener('shopify:block:select', function (e) { scan(e.target); });
  });
})();
